/* eslint-disable n/no-process-env */

const DEV_API_HOST = 'https://dapi.aivatar.ai'
const API_HOST = process.env.REACT_APP_API_HOST || DEV_API_HOST
// 테스트 상점 기본값은 dev 백엔드에서만 쓴다 — 운영에서 설정 누락이 테스트 상점 결제로 새지 않게
const IS_DEV_API = API_HOST === DEV_API_HOST

export default Object.freeze({
    NODE_ENV: process.env.NODE_ENV,

    API_HOST,
    WEBSOCKET_HOST: process.env.REACT_APP_WEBSOCKET_HOST || 'wss://dapi.aivatar.ai',

    // 결제 관련 환경변수
    IMP: process.env.REACT_APP_IMP || 'imp85016062',
    // 정기결제(빌링) MID — 기존 구독 결제용
    PG: process.env.REACT_APP_PG || 'tosspayments.iamporttest_4',
    // 일반결제(단건) — 크레딧 팩 단건결제용. 정기결제(PG)와 반드시 다른 상점·채널이다.
    //  정기결제 상점과 그 키는 반복 청구 전용 계약이라 단건 결제에 쓸 수 없다(정책 7절 · 명세 5-6).
    //  그래서 단건 설정이 비어 있으면 PG(정기결제)로 대체하지 않고 구매 자체를 막는다(fail-closed,
    //  utils/portone isOneTimePayConfigured). 서버는 결제가 어느 상점에서 났는지 검증할 수 없어
    //  화면 쪽 차단에 의존한다(aipark-front #279).
    //  - 기본값은 포트원 공용 테스트 상점(tosspayments.iamporttest_3 · 단건 채널키)이며, dev 백엔드를
    //    바라볼 때만 쓴다. 운영 빌드는 REACT_APP_PG_ONETIME_CHANNEL_KEY(또는 REACT_APP_PG_ONETIME)를
    //    반드시 넣어야 구매 진입점이 보인다.
    PG_ONETIME: process.env.REACT_APP_PG_ONETIME || (IS_DEV_API ? 'tosspayments.iamporttest_3' : ''),
    // 단건결제 채널키 — 신 콘솔에서 채널이 여러 개일 때 pg 문자열이 대표(빌링) 채널로 라우팅되는 문제를
    // 회피하기 위해 채널을 명시적으로 지정. (채널키는 공개 식별자라 FE 노출 OK) 없으면 위 PG_ONETIME(pg 문자열) 사용.
    PG_ONETIME_CHANNEL_KEY:
        process.env.REACT_APP_PG_ONETIME_CHANNEL_KEY ||
        (IS_DEV_API ? 'channel-key-48c961d9-6478-41ef-aca9-297de00ac285' : ''),
    PAY_NAME: process.env.REACT_APP_PAY_NAME || '최초인증결제',

    MIXPANEL_PROJECT_TOKEN: process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN || 'c34117c798256c8b691ec1d86762623f',

    VGEN_APP_BASE_URL: process.env.REACT_APP_VGEN_APP_BASE_URL || 'https://dvgen.aivatar.ai',
})
